import Button from 'components/generics/buttons/Button';
import { FlowComponentProps } from 'components/generics/flows/Flow';
import Typography from 'components/generics/texts/Typography';
import Timeline, { TimelineDataType } from 'components/generics/Timeline';
import usePortfolio from 'hooks/requests/portfolio/usePortfolio';
import useUserCash from 'hooks/requests/portfolio/useUserCash';
import classes from 'pages/profile/components/ProfileTabContent/Account/Advanced/components/DeleteAccountModalFlow/DeleteAccountSteps/index.module.scss';
import CheckIcon from 'public/assets/icons/activity_check.svg';
import { useEffect, useMemo, useState } from 'react';
import { parseMoney } from 'utils/money_utils';

const DeleteAccountModal = ({ onFinish }: FlowComponentProps) => {
  const { portfolio } = usePortfolio();
  const sharesNumber = portfolio?.shares;
  const { usableCash } = useUserCash();
  const [done, setDone] = useState(false);

  const currentStep = useMemo(() => {
    if (sharesNumber === 0) {
      return 2;
    }
    if (usableCash === 0) {
      return 2;
    }
    return 0;
  }, [sharesNumber, usableCash]);

  useEffect(() => {
    usableCash === 0 && setDone(true);
  }, [usableCash]);

  const data = [
    {
      title: 'Sell your shares',
      subtitle: `You currently own ${sharesNumber} shares.`,
    },
    {
      title: 'Dividend Collected. Yay!',
      subtitle: 'Consider this our goodbye gift.',
    },
    {
      title: 'Withdraw your money',
      subtitle: `Bring your balance from ${parseMoney(usableCash, {
        withCentsDisplay: true,
      })} to $0.`,
      stopStep: done,
    },
  ] as TimelineDataType;
  return (
    <>
      <Typography className={classes.title}>Deactivate your account</Typography>
      <Timeline
        className={classes.timeline}
        data={data}
        currentStep={currentStep}
        options={{
          passedCircleClassName: classes.passedCircleClassName,
          currentCircleClassName: classes.currentCircleClassName,
          nextCircleClassName: classes.nextCircleClassName,
          passedLineClassName: classes.passedLineClassName,
          nextLineClassName: classes.nextLineClassName,
          passedCircleIcon: CheckIcon,
          passedCircleIconClassName: classes.passedCircleIconClassName,
        }}
      />
      <Button
        onClick={onFinish}
        className={classes.button}
        disabled={!done}
      >
        Deactivate my account
      </Button>
    </>
  );
};
export default DeleteAccountModal;
